import { BaseInputModel } from '@/helpers/entities/models/BaseInputModel';
import { State } from '@/helpers/entities/enums/v2/State';
import { TaxType as DiscountType } from '@/helpers/entities/enums/v2/TaxType';
import { EcommerceProductPromoFreebieInputModel } from '@/helpers/entities/models/EcommerceProductFreebieInputModel';
import { omit } from 'lodash';
export class EcommerceProductPromoInputModel extends BaseInputModel {
    constructor(payload = null) {
        super();
        if (payload) {
            Object.assign(this, omit(payload, 'promoProducts'));
            this.state = State.idle;
            this.persistent = true;
            this.paymentOptions = payload.applicablePaymentOption;
            this.freebies = payload.promoProducts.map((product) => {
                return new EcommerceProductPromoFreebieInputModel(product);
            });
        }
        else {
            this.init();
        }
    }
    generateFreebie() {
        this.freebies.push(new EcommerceProductPromoFreebieInputModel());
    }
    get isPercentage() {
        return this.discountType === DiscountType.percentage;
    }
    get freebieUuids() {
        return this.freebies.map((freebie) => {
            return freebie.uuid;
        });
    }
    get undeletedFreebieUuids() {
        const undeleted = (freebie) => {
            return !freebie.isDeleted;
        };
        return this.freebies.filter(undeleted).map((freebie) => {
            return freebie.uuid;
        });
    }
    get deletedFreebieUuids() {
        const deleted = (freebie) => {
            return freebie.isDeleted && !!freebie.persistent;
        };
        return this.freebies.filter(deleted).map((freebie) => {
            return freebie.uuid;
        });
    }
    get newFreebieUuids() {
        const isNew = (freebie) => {
            return freebie.isNew;
        };
        return this.freebies.filter(isNew).map((freebie) => {
            return freebie.uuid;
        });
    }
    /**
     * Check if Freebie already exist in Promo instance
     * Might also contain new freebie instance, that's why we return false
     * when instance is greater than one(1)
     */
    freebieExists(val) {
        const uuids = this.undeletedFreebieUuids;
        const one = 1;
        const matches = uuids.filter((uuid) => val === uuid);
        return matches.length > one;
    }
    buildNewPromoParams() {
        return {
            discount: this.discount,
            discountType: this.discountType,
            promoProducts: this.newFreebieUuids,
            paymentOptions: this.paymentOptions,
        };
    }
    init() {
        this.uuid = null;
        this.discount = null;
        this.discountType = DiscountType.absolute;
        this.freebies = [];
        this.paymentOptions = 'to_all';
        this.state = State.new;
    }
}
